import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import InputGeral from "../Componets/InputGeral";
import LabelGeral from "../Componets/LabelGeral";
import Vector from "../imagem/Vector.svg";
import { CircularProgress } from "@mui/material";
import InputSenha from "../Componets/InputSenha";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 360,
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  height: "auto",
  p: 4,
  borderRadius: 3,
};

export default function RedefinirSenha({
  open,
  cancelar,
  enviarEmail,
  emailRedefinir,
  changeEmail,
  exibirEmailSenha, // Alterna a exibição do modal de redefinir senha
  codigoVerificacao,
  changeCodigoVerificacao,
  novaSenha,
  changeNovaSenha,
  confirmarSenha,
  changeConfirmarSenha,
  loadEnviarEmail,
  redefinirSenha,
}) {
  return (
    <div>
      <Modal
        open={open}
        onClose={cancelar}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {exibirEmailSenha ? (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "end",
                  }}
                >
                  <Button onClick={cancelar}>
                    <img src={Vector} alt="" />
                  </Button>
                </div>
                <Typography variant="h6" component="h6">
                  Redefinir senha
                </Typography>
              </div>

              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                  width: "100%",
                  marginTop: 40,
                }}
              >
                <LabelGeral
                  nome="E-mail"
                  style={{
                    justifyContent: "center",
                    display: "flex",
                    alignItems: "center",
                    fontFamily: "Roboto",
                    fontSize: 20,
                  }}
                />
                <InputGeral
                  value={emailRedefinir}
                  placeholder="Digite seu e-mail"
                  onChange={(e) => changeEmail(e.target.value)}
                />
              </div>

              <div
                className="buttons"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 40,
                }}
              >
                <Button
                  onClick={enviarEmail}
                  variant="contained"
                  style={{
                    color: "var(--cor-branco)",
                    backgroundColor: "var(--cor-roxoEscuro)",
                    border: "solid var(--cor-roxoEscuro)",
                    borderRadius: "0.5em",
                    fontSize: 20,
                    width: "100%",
                    marginBottom: 50,
                  }}
                >
                  {loadEnviarEmail ? (
                    <CircularProgress sx={{ color: "var(--cor-branco)" }} />
                  ) : (
                    "Enviar"
                  )}
                </Button>
              </div>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "end",
                  }}
                >
                  <Button onClick={cancelar}>
                    <img src={Vector} alt="" />
                  </Button>
                </div>
                <Typography variant="h6" component="h6">
                  Redefinir senha
                </Typography>
                <p>
                  {`Se o endereço de email (${emailRedefinir}) existir em nossa base
                  de dados, você receberá um código de verificação.`}
                </p>
              </div>

              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                  width: "100%",
                  marginTop: 30,
                }}
              >
                <LabelGeral
                  nome="Código de verificação"
                  style={{
                    justifyContent: "center",
                    display: "flex",
                    alignItems: "center",
                    fontFamily: "Roboto",
                    fontSize: 20,
                  }}
                />
                <InputGeral
                  value={codigoVerificacao}
                  placeholder="Digite o código de verificação"
                  onChange={(e) => changeCodigoVerificacao(e.target.value)}
                />
              </div>

              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                  width: "100%",
                  marginTop: 30,
                }}
              >
                <LabelGeral
                  nome="Nova senha"
                  style={{
                    justifyContent: "center",
                    display: "flex",
                    alignItems: "center",
                    fontFamily: "Roboto",
                    fontSize: 20,
                  }}
                />
                <InputSenha value={novaSenha} changeValue={changeNovaSenha} placeholder="Digite sua nova senha"/>
              </div>

              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                  width: "100%",
                  marginTop: 30,
                }}
              >
                <LabelGeral
                  nome="Confirmar senha"
                  style={{
                    justifyContent: "center",
                    display: "flex",
                    alignItems: "center",
                    fontFamily: "Roboto",
                    fontSize: 20,
                  }}
                />
                <InputSenha value={confirmarSenha} changeValue={changeConfirmarSenha} placeholder="Confirme sua nova senha"/>
              </div>
              <p style={{ marginTop: 20, color: "red", fontSize: 14 }}>
                *Mínimo de 8 caracteres
              </p>

              <div
                className="buttons"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: 50,
                  width: "100%",
                }}
              >
                <Button
                  onClick={cancelar}
                  variant="contained"
                  style={{
                    color: "var(--cor-roxoEscuro)",
                    backgroundColor: "var(--cor-branco)",
                    border: "solid var(--cor-roxoEscuro)",
                    borderRadius: "0.5em",
                    fontSize: 20,
                    width: "48%",
                  }}
                >
                  Cancelar
                </Button>
                <Button
                  onClick={redefinirSenha}
                  variant="contained"
                  style={{
                    color: "var(--cor-branco)",
                    backgroundColor: "var(--cor-roxoEscuro)",
                    border: "solid var(--cor-roxoEscuro)",
                    borderRadius: "0.5em",
                    fontSize: 20,
                    width: "48%",
                  }}
                >
                  Enviar
                </Button>
              </div>
            </div>
          )}
        </Box>
      </Modal>
    </div>
  );
}
